export const SENTIMENT_LIST = [
  { value: 'neutral', text: 'Neutral' },
  { value: 'positive', text: 'Positive' },
  { value: 'nagative', text: 'Negative' }
]



// WEBPACK FOOTER //
// ./src/constants/sentiment.js